<template>
    <div>
        <div class="content-box mr60">
            <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item label="拒绝原因：" prop="rejected_reason">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请输入拒绝的理由，50字之内"
                        v-model.trim="formItem.rejected_reason" clearable maxlength="50" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<!-- 工单管理 拒绝素材弹框-->
<script>

import API from "@/api/workOrder/material.js"
export default {
    name: "rejectModal",
    props: ['cbs', 'id', 'detailId', 'type'],
    data() {
        return {
            formLoading: false,
            formItem: {
                rejected_reason: '',
            },
            rules: {
                rejected_reason: [
                    { required: true, message: '请输入拒绝的理由，50字之内', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入拒绝的理由，50字之内', trigger: 'blur' }
                ],
            },
        }
    },
    mounted() {
    },
    methods: {
        submitModal() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.type == 'group') {
                        this.fetchBatchReject(this.id, this.detailId)
                    } else {
                        this.fetchReject(this.id)
                    }
                } else {
                    return false;
                }
            });

            // this.cbs.onSubmit()
        },
        hideModal() {
            this.$emit('close');
        },
        //批量拒绝
        fetchBatchReject(id, detail_id) {
            this.formLoading = true
            let params = {
                rejected_reason: this.formItem.rejected_reason
            }
            if (id) {
                params.material_id = id
            }
            if (detail_id) {
                params.detail_id = detail_id
            }
            API.postWorkOrderBatchReject(params).then(res => {
                this.$message.success(res.info)
                this.cbs.onSubmit()
                this.formLoading = false
            }, err => {
                this.$message.error(err.info)
            }).finally(() => {
                this.formLoading = false
            })
        },
        //拒绝
        fetchReject(id) {
            this.formLoading = true
            API.postWorkOrderReject({ material_id: id, rejected_reason: this.formItem.rejected_reason }).then(res => {
                this.$message.success(res.info)
                this.cbs.onSubmit()
                this.formLoading = false
            }, err => {
                this.$message.error(err.info)
            }).finally(() => {
                this.formLoading = false
            })
        },
    }
}
</script>

<style scoped></style>
